export enum OrganizationTabKeys {
  Dashboard = "dashboard",
  Leagues = "leagues",
  Competitions = "competitions",
  Conferences = "conferences",
  EntityGroups = "entity-groups",
  Entities = "entities",
  Sites = "sites",
  Venues = "venues",
  Persons = "persons",
  Permissions = "permissions",
  StandingsConfigurations = "standings-configurations",
  LeadersQualification = "leaders-qualification",
  MatchProfiles = "match-profiles",
  Conducts = "conducts",
}
